import React from 'react';
import { useTranslation } from 'react-i18next';
import { Review } from '../../types';
import StarRating from './StarRating';
import './ReviewList.css';

interface ReviewListProps {
    reviews: Review[];
    loading?: boolean;
}

const ReviewList: React.FC<ReviewListProps> = ({ reviews, loading }) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <div className="review-list-loading">
                <div className="loading-spinner"></div>
                <p>{t('reviews.loading')}</p>
            </div>
        );
    }

    if (reviews.length === 0) {
        return (
            <div className="review-list-empty">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                <h3>{t('reviews.noReviews')}</h3>
                <p>{t('reviews.beFirst')}</p>
            </div>
        );
    }

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="review-list">
            {reviews.map((review) => (
                <div key={review.id} className="review-card">
                    <div className="review-header">
                        <div className="review-author">
                            <div className="author-avatar">
                                {review.customer_name.charAt(0).toUpperCase()}
                            </div>
                            <div className="author-info">
                                <h4 className="author-name">{review.customer_name}</h4>
                                <p className="review-date">{formatDate(review.created_at)}</p>
                            </div>
                        </div>
                        <StarRating rating={review.rating} readOnly size="small" />
                    </div>
                    <div className="review-content">
                        <p>{review.comment}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ReviewList;
